var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full px-4"},[_c('h1',{staticClass:"xl"},[_vm._v("Пользовательское соглашение")])])}]

export { render, staticRenderFns }